module.exports = __webpack_public_path__ + "static/media/1029624.5c2541c1.jpg";